export default __webpack_public_path__ + "static/blog-image-5-cf8494d0551096e0975b43593ec34ec8.png";